import React from 'react'
import { Link } from 'react-router-dom'
//third party
import { useSelector, useDispatch } from 'react-redux'
import { changeState } from '../redux/aside'

const Header = () => {
    const user = useSelector((state) => state.user)
    const dispatch = useDispatch()
    const handleAside = () => {
        dispatch(changeState(true))
    }
    return (
        <div className='header'>
            <Link to={'/'} className='icon'>
                <img src="https://dl.newwebinar.ir/base/logo2.png" alt="" />
            </Link>
            <div className='desktop-menu'>
                <Link to={'/journals'}>
                    <i className='fas fa-blog'></i>
                    <span>نشریات دانشگاهی</span>
                </Link>
                <Link to={'/contactUs'}>
                    <i className='fas fa-phone'></i>
                    <span>تماس با ما</span>
                </Link>
                <Link to={'/webinars'}>
                    <i className='fas fa-microphone-alt'></i>
                    <span>دوره های آموزشی</span>
                </Link>
                {/* <Link to={'/aboutUs'}>
                    <i className='fas fa-hands-helping'></i>
                    <span>همکاران ما</span>
                </Link> */}
                <Link to={'/conferences'}>
                    <i className='fas fa-microphone-alt'></i>
                    <span>همایش ها و کنگره ها</span>
                </Link>
                <Link to={'/books'}>
                    <i className='fa fa-book'></i>
                    <span>کتاب ها</span>
                </Link>
                <Link to={'/files'}>
                    <i className='fa fa-folder'></i>
                    <span>دوره های آفلاین</span>
                </Link>



                {user.value == "" ? (
                    <>
                        <Link to={'/login'}> 
                            <i className='fa fa-user'></i>
                            <span>ورود</span>
                        </Link>
                        <Link to={'/register'}>
                            <i className='fas fa-user-plus'></i>
                            <span>ثبت نام</span>
                        </Link>
                    </>
                ) : (

                    <>
                        <Link to={'/dashboard'}>
                            <i className='fas fa-user-circle'></i>
                            <span>حساب کاربری</span>
                        </Link>
                        <Link to={'/logOut'}>
                            <i className='fas fa-sign-out-alt'></i>
                            <span>خروج</span>
                        </Link>
                    </>
                )}

            </div>
            <div className='mobile-menu' onClick={handleAside}>
                <i className=' fas fa-bars'>
                </i>
            </div>
        </div>
    )
}


export default Header